import styled from 'styled-components';

import { Grid as SemanticGrid } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Grid = styled(SemanticGrid)`
  &&& {
    margin-bottom: 0px;
    margin-top: 0px;

    .row {
      padding: 5px 0;
    }
  }
`;

export const FieldName = styled(TextLayoutComponent.Bold)`
`;

export const FieldValue = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

export const PreviewStudyContainer = styled.div`
  display: flex;
  ${({ spaceBetween }) => spaceBetween && 'justify-content: space-between;'}
`;
